<template>
  <div class="Dashboard">
    <div class="glavni">
      <nav class="navbar navbar-expand-lg navbar-dark">
        <a class="navbar-brand" href="#">
          <img src="../assets/img/demo.svg" width="100" height="48" alt="logo">
        </a>
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav mr-auto">
            <li class="nav-item active btn">
              <router-link to="/Users" class="nav-link" href="#">
                Users
                <span class="sr-only">(current)</span>
              </router-link>
            </li>
            <li class="nav-item btn">
              <router-link to="/Messages" class="nav-link" href="#">Messages</router-link>
            </li>
          </ul>
        </div>
      </nav>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
    name: "Dashboard",
};
</script>

<style>
.glavni {
  background-color: #202646;
}
</style>
